/* eslint-disable react/prop-types */
import './Table.css';
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AddItem from "../Carrito/AddItem";
import sinimagen from './sinimagen.gif';
import React, { useContext } from 'react';
import { authContext } from '../Context/AuthContext';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Tables(props) {
  const navigate = useNavigate()
  // const articulosXMarca = props.articulo;
  const articulosXMarca = props.articulosXMarca
  const { token } = useContext(authContext);
  const pais = process.env.REACT_APP_COUNTRY || 'ARG';
  const [t] = useTranslation("global")


  const formatNumber = (number) => {
  // Convierto a num
  const num = typeof number === 'number' ? number : parseFloat(number);
  
  // Verifico si es valido
  if (isNaN(num)) return '0,00';
  
  // Formato con separadores de miles y decimales
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};

const renderStockInfo = (articulo) => {
  if (articulo?.Stock <= 0 || articulo?.Precio === undefined) return null;
  
  return (
      <>
          Stock: {articulo.Stock || 0}
          &nbsp;
          &nbsp;
          &nbsp;
          &nbsp;
          &nbsp;
          &nbsp;
          &nbsp;
          {articulo?.Moneda_Signo && `Valor: ${articulo.Moneda_Signo} ${formatNumber(articulo.Precio)}`}
      </>
  );
};

const renderPriceNote = () => {
  if (pais === "PA") {
      return '*No incluye ITBMS';
  } else if (pais !== "USA") {
      return '*No incluye IVA';
  }
  return null;
};

const renderProductLink = (articulo) => {
        const linkProps = {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.25rem 0.5rem',
                fontSize: '0.75rem',
                justifyContent: 'center',
                minWidth: '120px',
                textDecoration: 'none',
                color: '#dc3545',
                border: '1px solid #dc3545',
                borderRadius: '0.25rem',
                backgroundColor: 'transparent',
                transition: 'background-color 0.2s, color 0.2s',
            },
            to: `/detalle?sku=${articulo.Alias || ''}`,
            onClick: (event) => {
                if (event.button === 1) {
                    window.open(`/detalle?sku=${articulo.Alias || ''}`, "_blank");
                    event.preventDefault();
                }
            },
            onMouseEnter: (e) => {
                e.currentTarget.style.backgroundColor = '#dc3545';
                e.currentTarget.style.color = 'white';
            },
            onMouseLeave: (e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#dc3545';
            }
        };

        return (
            <Link {...linkProps}>
                {t("producto.ver-producto")}
            </Link>
        );
    };

    const renderAddItem = (articulo) => {
      if (articulo.Precio === undefined || articulo.Precio === null) return null;
      
      return (
          <div className="btnTables">
              <AddItem producto={articulo} />
          </div>
      );
  };

  return (
    <>
      <div className="table-containereo">
        <Table hover variant='light'>
          <tbody>
            {articulosXMarca.map((articulo, idx) => {
              return (
                <tr key={idx}>
                  {/* <td className="fondoBlanco">
                    <img src={articulo.Imagenes ? process.env.PUBLIC_URL + `/articulos/thumbs/${encodeURIComponent(String(articulo.Imagenes.split(',')[0]))}` : sinimagen}
                      alt="sbox"
                    />
                  </td> */}
                  <td className='quitoPaddingTable'>
                  <Link 
                        to={`/detalle?sku=${articulo.Alias}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        <h6 className="table-name-product hover-imagen">
                          {articulo.Nombre || 'Nombre no disponible'}
                          <span className="mini-image-tooltip">
                            <img
                              src={
                                articulo.Imagenes
                                  ? process.env.PUBLIC_URL + `/articulos/thumbs/${encodeURIComponent(String(articulo.Imagenes.split(',')[0]))}`
                                  : sinimagen
                              }
                              alt="vista previa"
                            />
                          </span>
                        </h6>
                  </Link>

                                  <div className="articulo-info-linea">
                                        <p className="numero-de-parte">
                                            Marca: {articulo.Marca || 'N/A'}
                                        </p>

                                        <p className="numero-de-parte">
                                            SKU: {articulo.Alias || 'N/A'}
                                        </p>

                                        <p className="numero-de-parte">
                                            {renderStockInfo(articulo)}
                                        </p>

                                        {articulo.Precio !== undefined && (
                                            <p className='precios-sin-iva-card'>
                                                {renderPriceNote()}
                                            </p>
                                        )}
                                    </div>

                    
                  </td>
                  <td className="table-botonera">
                                <div className="button-container">
                                    <div className="button-contenedor-principal">
                                        <div className="logged-buttons-categorias">
                                            <div className="ver-producto-container">
                                                {!token ? (
                                                    renderProductLink(articulo)
                                                ) : (
                                                    <div className='d-flex justify-content-evenly gap-3'>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            {renderProductLink(articulo)}
                                                        </div>
                                                        {renderAddItem(articulo)}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
}

